const React = require('react');
const upperFirst = require('mn-utils/upperFirst');

const {DisplayDataAdmin, DisplayDateTimeAdmin, DisplayAmountAdmin} = require('../../../../../../../dumb/DisplayData/');
const {AdminTableRow} = require('../../../../../../../dumb/TableRow/');
const Tooltip = require('../../../../../../../dumb/Tooltip/B');

const {getAdminRetailersLink} = require('../../../../../../../../utils/adminLinkCtor');
const {LINK_ADMIN_ADD} = require("../../../../../../../../constants/links");
const Ripple = require("../../../../../../../dumb/Ripple");
const openPopupForcedSignOut = require("../../../../utils/openPopupForcedSignOut");
const {default: ExitToApp} = require("@material-ui/icons/ExitToApp");

module.exports = ({data, index, update}) => {
  const {
    id,
    created_at,
    status,
    login,
    name,
    kyc_stage,
    balances
  } = data;

  const balance = (balances || [])[0] || {};
  const link = status === 'active'
    ? getAdminRetailersLink(`/${id}`, '/')
    : getAdminRetailersLink(`${LINK_ADMIN_ADD}?userId=${id}`)

  return (
    <AdminTableRow className="f12" link={link} index={index}>
      <div className="wmin100 fx1 bold">
        <DisplayDataAdmin>
          {name}
        </DisplayDataAdmin>
      </div>
      <div className="wmin100 fx1">
        <Tooltip value={login} onClick={(e) => e.stopPropagation()}>
          <a
            href={`mailto:${login}`}
            target="_blank"
            rel="noopener"
          >
            {login}
          </a>
        </Tooltip>
      </div>
      <div className="wmin100 fx1">
        {kyc_stage}
      </div>
      <div className="wmin100 fx1">
        <DisplayDateTimeAdmin date={created_at} />
      </div>
      <div className="wmin100 fx1 bold">
        {status ? upperFirst(status) : '-'}
      </div>
      <div className="wmin100 fx1 bold">
        <DisplayAmountAdmin
          amount={balance.available}
          symbol={balance.asset_code || 'USDC'}
          type="coin"
        />
      </div>
      {/*<div className="w100">*/}
      {/*  <Tooltip title="Sign out user" disabledCopy>*/}
      {/*    <Ripple*/}
      {/*      className="w42 h42 layoutRow jcC aiC p7 r7 (dB|w25|h25|fill3E4044)>.MuiSvgIcon-root (bgc0.25):h:not[.disabled] o15.disabled"*/}
      {/*      onClick={() => openPopupForcedSignOut(data, update)}*/}
      {/*    >*/}
      {/*      <ExitToApp />*/}
      {/*    </Ripple>*/}
      {/*  </Tooltip>*/}
      {/*</div>*/}
    </AdminTableRow>
  );
};
